// ═══════════════════════════════════════════════════════════════
// API: Document Templates
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const documentTemplatesAPI = {
  getAll:        (params = {}) => api.get('/document-templates', { params }).then(r => r.data),
  getById:       (id)          => api.get(`/document-templates/${id}`).then(r => r.data),
  create:        (data)        => api.post('/document-templates', data).then(r => r.data),
  update:        (id, data)    => api.put(`/document-templates/${id}`, data).then(r => r.data),
  deactivate:    (id)          => api.delete(`/document-templates/${id}`).then(r => r.data),
  initDefaults:  ()            => api.post('/document-templates/init-defaults').then(r => r.data),
  generate:      (id, data)    => api.post(`/document-templates/${id}/generate`, data).then(r => r.data),
  preview:       (data)        => api.post('/document-templates/preview', data).then(r => r.data),
};
